import { TLD } from '@/common/constants.js'

export const PUBLIC_ROUTE_PATHS = Object.freeze({
    en: Object.freeze({
        Tapgiant: '/',
        how_it_works: '/how-it-works',
        pricing: '/pricing',
        store_provisioning: '/store-provisioning',
        push_notifications: '/enable-delivery-notifications-iphone',
        push_notifications_android: '/enable-delivery-notifications-android',
        contact: '/contact',
        privacy: '/privacy',
        terms: '/terms',
        legal: '/legal'
    }),
    ro: Object.freeze({
        Tapgiant: '/',
        how_it_works: '/cum-functioneaza',
        pricing: '/preturi',
        store_provisioning: '/aprovizionare-puncte-de-lucru',
        push_notifications: '/activeaza-notificarile-pentru-livrari-iphone',
        push_notifications_android: '/activeaza-notificarile-pentru-livrari-android',
        contact: '/contact',
        privacy: '/politica-de-confidentialitate',
        terms: '/termeni-si-conditii',
        legal: '/date-companie'
    })
})

export const PUBLIC_DOMAIN_LOCALE = TLD.endsWith('.ro') ? 'ro' : 'en'

export function getPublicPath (routeName, locale = PUBLIC_DOMAIN_LOCALE) {
    const paths = PUBLIC_ROUTE_PATHS[locale] || PUBLIC_ROUTE_PATHS.en
    return paths[routeName] || null
}

export function getPublicOrigin (locale) {
    return locale === 'ro' ? 'https://www.tapgiant.ro' : 'https://www.tapgiant.com'
}

export function isTapgiantPublicDomain () {
    return TLD === 'tapgiant.ro' || TLD === 'tapgiant.com'
}
